module.exports = __webpack_public_path__ + "static/media/petInsurance.6c7b03c0.png";